
import { computed, defineComponent } from 'vue'

export default defineComponent({
    props: {
        modelValue: {
            type: Number,
            default: 1
        },
        totalPages: {
            type: Number,
            default: 1
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['update:modelValue', 'change'],
    setup(props, { emit }) {
        const onUpdate = (page: number) => {
            emit('update:modelValue', page)
            emit('change', page)
        }

        const onFirstPage = () => {
            if (props.disabled) return
            onUpdate(1)
        }

        const onPreviousPage = () => {
            if (props.disabled || props.modelValue === 1) return
            onUpdate(props.modelValue - 1)
        }

        const onNextPage = () => {
            if (props.disabled || props.modelValue >= props.totalPages) return
            onUpdate(props.modelValue + 1)
        }

        const onLastPage = () => {
            if (props.disabled || props.modelValue >= props.totalPages) return
            onUpdate(props.totalPages)
        }

        const onChangePage = (page: number) => {
            if (props.disabled) return
            onUpdate(page)
        }

        const controlsCount = computed(() => {
            const total = props.totalPages
            const current = props.modelValue
            const max = 4

            if (total <= max) {
                return Array.from({ length: total }, (_, i) => i + 1)
            }

            if (current > total - max) {
                return Array.from(
                    { length: max },
                    (_, i) => total - max + 1 + i
                )
            }

            const blockStart = Math.floor((current - 1) / max) * max + 1

            return Array.from(
                { length: max },
                (_, i) => blockStart + i
            )
        })

        return {
            onFirstPage,
            onPreviousPage,
            onNextPage,
            onLastPage,
            onChangePage,
            controlsCount
        }
    }
})
